/**
 * /me — current-user profile + 152-ФЗ consent endpoints.
 *
 * Mirrors os-core/api/me.py (Sprint BB). Drives the "Privacy"
 * settings section, the re-consent modal at login, and the
 * deletion-request flow.
 */

import { api, type RequestOptions } from "./client";


export interface MeDto {
  user_id:                 string;
  email:                   string;
  full_name:               string | null;
  tenant_id:               string;
  email_verified_at:       string | null;
  pdn_consent_accepted_at: string | null;
  pdn_consent_version:     string | null;
  deletion_requested_at:   string | null;
  needs_consent_refresh:   boolean;
  // Sprint EA-4 — user's explicit language override.
  // `null` means "inherit tenant default" (see ADR 0014).
  locale:                  "ru" | "en" | null;
}


export interface MeMessageDto {
  message: string;
}


export const meApi = {
  get(opts?: RequestOptions): Promise<MeDto> {
    return api.get<MeDto>("/me", opts);
  },

  acceptConsent(opts?: RequestOptions): Promise<MeMessageDto> {
    return api.post<MeMessageDto>("/me/consent/accept", undefined, opts);
  },

  requestDeletion(opts?: RequestOptions): Promise<MeMessageDto> {
    return api.post<MeMessageDto>("/me/delete", undefined, opts);
  },

  cancelDeletion(opts?: RequestOptions): Promise<MeMessageDto> {
    return api.delete<MeMessageDto>("/me/delete", opts);
  },

  /** Sprint EA-4. Pass `null` to clear the override and fall
   *  back to the tenant's default. */
  setLocale(
    locale: "ru" | "en" | null,
    opts?: RequestOptions,
  ): Promise<MeMessageDto> {
    return api.patch<MeMessageDto>("/me/locale", { locale }, opts);
  },
};
